<template>
  <v-row>
    <!-- For delivery -->
    <template
      v-if="orderType.Type === 'Delivery' || orderType.Type === 'Shiplee'"
    >
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title class="py-2">{{
            $translate('DELIVERY_ADDRESS')
          }}</v-card-title>
          <v-card-text>
            <div>{{ `${userDetails.firstName} ${userDetails.lastName}` }}</div>
            <div>{{ `${userDetails.street} ${userDetails.houseNo}` }}</div>
            <div>{{ `${userDetails.postalCode} ${userDetails.city}` }}</div>
            <div>{{ `${userDetails.phoneNo}` }}</div>
            <div>{{ `${userDetails.email}` }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title class="py-2">{{
            $translate('DELIVERY_DATE')
          }}</v-card-title>
          <v-card-text>
            <div>{{ orderType.EventTranslationName }}</div>
            <div class="font-weight-bold">
              {{ computedDateFormattedStartDate }}
              {{
                `${orderDetails.StartTime.StartTime} - ${orderDetails.StartTime.EndTime}`
              }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </template>

    <!-- For pickup -->
    <template v-else-if="orderType.Type === 'PickUp'">
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title class="py-2">{{
            orderType.EventTranslationName
          }}</v-card-title>
          <v-card-text>
            <div>{{ `${orderType.Street} ${orderType.Nr}` }}</div>
            <div>{{ `${orderType.PostalCode} ${orderType.City}` }}</div>
            <div>{{ orderType.Telephone }}</div>
            <div>{{ orderType.Email }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title class="py-2">{{
            $translate('PICKUP_DATE_TIME')
          }}</v-card-title>
          <v-card-text>
            <div>{{ `${userDetails.firstName} ${userDetails.lastName}` }}</div>
            <div>{{ `${userDetails.phoneNo}` }}</div>
            <div class="mb-2">{{ `${userDetails.email}` }}</div>
            <div class="font-weight-bold">
              {{ computedDateFormattedStartDate }}
              {{
                `${orderDetails.StartTime.StartTime} - ${orderDetails.StartTime.EndTime}`
              }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </template>

    <template v-else>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title class="py-2">{{
            $translate('USER_DETAILS')
          }}</v-card-title>
          <v-card-text>
            <div>{{ `${userDetails.firstName} ${userDetails.lastName}` }}</div>
            <div>{{ `${userDetails.phoneNo}` }}</div>
            <div class="mb-2">{{ `${userDetails.email}` }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </template>

    <v-col cols="12" v-if="notes !== ''">
      <v-card flat>
        <v-card-title class="py-2">{{ $translate('NOTE') }}</v-card-title>
        <v-card-text>
          <div>{{ notes }}</div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Booking_Overview_OrderData',
  computed: {
    userDetails() {
      return this.$store.getters.getUserDetails;
    },
    orderDetails() {
      return this.$store.getters.getOrderDetails;
    },
    orderType() {
      return this.$store.getters.getOrderType;
    },
    listOfTickets() {
      return this.$store.getters.getListOfTickets;
    },
    recipientUserObject() {
      return this.$store.getters.getRecipientUserObject;
    },
    notes() {
      return this.$store.getters.getNotes;
    },
    computedDateFormattedStartDate() {
      return this.formatDate(this.orderDetails.StartDate);
    },
  },
  methods: {
    formatDate(data) {
      if (!data) return '';
      const [year, month, day] = data.split('-');
      return `${day}-${month}-${year}`;
    },
  },
};
</script>
